<!--<section id="HomeSection" class="hero-section">-->
<!--  <div class="container">-->
<!--    <div class="overlay"></div>-->
<!--    <div class="hero-div">-->
<!--      <div class="hero-title">-->
<!--        <h1 i18n>Grow your business online</h1>-->
<!--        <h2 i18n>Join Akl Bayti and become one of the elite homemade restaurants out there</h2>-->
<!--      </div>-->
<!--      <button class="button-primary button-with-image" routerLink="/merchants/signup" routerLinkActive="active"-->
<!--              ariaCurrentWhenActive="page" i18n>Join Us Now-->
<!--        <div class="i-image-to-flip"><img src="assets/arrow-right.svg" /></div>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->


<div class="main-page-layout">
  <section id="hero-section">
    <hero-section></hero-section>
  </section>
  <section id="about-us">
    <about-us></about-us>
  </section>
  <section id="benefits">
    <benefits></benefits>
  </section>
  <section id="how-it-works">
    <how-it-works></how-it-works>
  </section>
  <section id="community">
    <community></community>
  </section>
  <section id="faqs">
    <faqs></faqs>
  </section>
  <section id="enhance-services">
    <enhance-services></enhance-services>
  </section>
  <section id="join-us">
    <join-us></join-us>
  </section>
</div>
